export const ONE_DAY_IN_SECONDS = 86_400
export const ONE_WEEK_IN_SECONDS = 604_800
export const EIGHT_WEEKS_IN_SECONDS = 4_838_400
export const THIRTY_MINUTES_IN_SECONDS = 1_800
